import { createContext } from "react";

/* Which settings look the enclosing SettingsGroup draws. SettingsGroup
   PROVIDES it and SettingRow READS it, so rows inside a
   `variant="settings"` group take the Direction B row (PB-5134) without a
   prop on every row. Internal: not exported from the barrel. */

export type SettingsLook = "default" | "settings";

export const SettingsLookContext = createContext<SettingsLook>("default");
